import { CustomerAccountItem, ViewItems } from '@inyova/models';

import { createAction, props } from '@ngrx/store';

import { BiometricLogin } from '@shared/models/State';

import { Stock } from './shared/models/Home';

export const setBiometricLogin = createAction('[Root] Set biometric login', props<{ payload: BiometricLogin }>());
export const setSelectedAccount = createAction('[Root] Set selected Account', props<{ account: CustomerAccountItem }>());
export const setCrowdInvestorAccountStatus = createAction('[Root] Set crowd investor account status', props<{ active: boolean }>());

export const fetchFundBreakdownForAccount = createAction('[Root] Fetch fund breakdown for account', props<{ accountID: string }>());
export const fetchFundBreakdownForAccountSuccess = createAction(
  '[Root] Fetch fund breakdown for account success',
  props<{ accountID: string; stocks: Stock[]; cash: number; language: string }>()
);
export const fetchFundBreakdownForAccountFail = createAction('[Root] Fetch fund breakdown for account fail', (accountId: string) => ({ accountId }));

export const getFundBreakdowns = createAction('[Root] Get fund breakdowns');
export const updateFundBreakdownsOnLanguageChange = createAction('[Root] Update fund breakdowns on language change');

export const getViewedItems = createAction('[Root] Get viewed items');
export const getViewedItemsSuccess = createAction('[Root] Get viewed items success', (viewItemsList: string[]) => ({ viewItemsList }));
export const getViewedItemsFail = createAction('[Root] Get viewed items fail');

export const setItemAsViewed = createAction('[Root] Set item as viewed', (item: ViewItems) => ({ item }));
export const setItemAsViewedSuccess = createAction('[Root] Set item as viewed success', (item: ViewItems) => ({ item }));
export const setItemAsViewedFail = createAction('[Root] Set item as viewed fail');

export const unsetItemAsViewed = createAction('[Root] Unset item as viewed', (item: ViewItems) => ({ item }));
export const unsetItemAsViewedSuccess = createAction('[Root] Unset item as viewed success', (item: ViewItems) => ({ item }));
export const unsetItemAsViewedFail = createAction('[Root] Unset item as viewed fail');
